import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel, ConfigurationPanel } from '.';
import { AiOutlineControl } from "react-icons/ai";
import { ListPanel } from "./ListPanel";
import {SideviewPanel} from "./SideviewPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: AiOutlineControl,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    ListPanel: ListPanel,
    SideViewPanel: SideviewPanel,
    isSmartApp: true,
    createConfig:     {
        group: 'Functions',
        name: "Controlled PID controller (loop object)",
        description: "Controlled PID controller",
        panel: OverviewPanel,
        defaultState: {  y: 50 },
        defaultProperties: [
            { key: 'Y', value: 50 },
        ]
    },
}